import { SEMANTIC_COLORS } from '~~/tailwind-config/colors'
import { TYPOGRAPHY_CONFIG } from '~~/tailwind-config/typography'

type TToken = { name: string; value: string | number }

type TTokens = TToken[]

type TDesignTokensKeys =
  | 'colors'
  | 'shadows'
  | 'fontSize'
  | 'spacing'
  | 'lineHeight'
  | 'weight'
  | 'textDecoration'

type TDesignTokens = {
  [K in TDesignTokensKeys]?: TTokens
}

const buildColors = () => {
  const out: TTokens = []

  for (const [key, value] of Object.entries(SEMANTIC_COLORS)) {
    if (Object.prototype.toString.call(value) === '[object Object]') {
      for (const [subKey, subValue] of Object.entries(value)) {
        if (Object.prototype.toString.call(subValue) === '[object Object]') {
          for (const [subSubKey, subSubValue] of Object.entries(subValue)) {
            if (typeof subSubValue === 'string') {
              out.push({
                name: `${key}.${subKey}.${subSubKey}`,
                value: subSubValue,
              })
            }
          }
        } else {
          out.push({ name: `${key}.${subKey}`, value: subValue })
        }
      }
    }

    if (typeof value === 'string') {
      out.push({ name: key, value })
    }
  }

  return out
}

const buildTypography = () => {
  const out: {
    fontSize: TTokens
    lineHeight: TTokens
    fontWeight: TTokens
    textDecoration: TTokens
    letterSpacing: TTokens
  } = {
    fontSize: [],
    lineHeight: [],
    fontWeight: [],
    textDecoration: [],
    letterSpacing: [],
  }

  for (const [key, value] of Object.entries(TYPOGRAPHY_CONFIG)) {
    const varSlug = key.toLowerCase().trim().replace(/\s+/g, '-')

    out.fontSize.push({
      name: key,
      value: `var(--${varSlug}-font-size, ${value[0] as string})`,
    })

    if (
      typeof value[1] === 'object' &&
      value[1] !== null &&
      'lineHeight' in value[1]
    ) {
      out.lineHeight.push({
        name: key,
        value: `var(--${varSlug}-line-height, ${value[1].lineHeight})`,
      })
    }

    if (
      typeof value[1] === 'object' &&
      value[1] !== null &&
      'fontWeight' in value[1]
    ) {
      out.fontWeight.push({
        name: key,
        value: `var(--${varSlug}-font-weight, ${value[1].fontWeight})`,
      })
    }

    if (
      typeof value[1] === 'object' &&
      value[1] !== null &&
      'textDecoration' in value[1]
    ) {
      out.textDecoration.push({
        name: key,
        value: `var(--${varSlug}-text-decoration, ${value[1].textDecoration})`,
      })
    }

    if (
      typeof value[1] === 'object' &&
      value[1] !== null &&
      'letterSpacing' in value[1]
    ) {
      out.letterSpacing.push({
        name: key,
        value: `var(--${varSlug}-letter-spacing, ${value[1].letterSpacing})`,
      })
    }
  }

  return out
}

export const designTokens: TDesignTokens = {
  colors: buildColors(),
  ...buildTypography(),
}
